module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("40mDJ"))).then(() => module.bundle.root('d181N'));